import { useBlobUrl } from './use-blob-url';
import { useSecureBlob } from './use-secure-blob';

export function useSecureBlobUrl(url: string | null) {
  const blob = useSecureBlob(url);
  const blobUrl = useBlobUrl(blob);

  return blobUrl;
}
